const BACKEND = process.env.REACT_APP_BACKEND_URL;

let _getToken = () => localStorage.getItem("access_token");
let _onUnauthorized = () => {};

export function configureApi({ getToken, onUnauthorized }) {
  if (getToken) _getToken = getToken;
  if (onUnauthorized) _onUnauthorized = onUnauthorized;
}

export function getBackendUrl() {
  return BACKEND;
}

export async function apiFetch(path, options = {}) {
  const token = _getToken();
  const headers = { ...options.headers };

  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }

  const res = await fetch(`${BACKEND}${path}`, { ...options, headers });

  if (res.status === 401 && !path.includes("/auth/")) {
    _onUnauthorized();
    throw new Error("Session expired. Please sign in again.");
  }

  return res;
}
